import { CallContent } from "../../../Components/CallApp/CallApp";

export const BuckinghamCallContent: CallContent[] = [
  {
    Contact: "Alex",
    date: "19 Oct 2024",
    time: "6:22pm",
    type: "incoming",
  },
  {
    Contact: "Rupert Langsford",
    date: "19 Oct 2024",
    time: "6:21pm",
    type: "missed",
  },
  {
    Contact: "Kasper",
    date: "18 Oct 2024",
    time: "7:48pm",
    type: "outgoing",
  },
  {
    Contact: "Kasper",
    date: "18 Oct 2024",
    time: "3:41pm",
    type: "missed",
  },
  {
    Contact: "Papa",
    date: "18 Oct 2024",
    time: "12:51pm",
    type: "incoming",
  },
  {
    Contact: "Mama",
    date: "18 Oct 2024",
    time: "9:49am",
    type: "incoming",
  },
  {
    Contact: "Mama",
    date: "16 Oct 2024",
    time: "10:07pm",
    type: "outgoing",
  },
  {
    Contact: "Kasper",
    date: "16 Oct 2024",
    time: "00:14am",
    type: "outgoing",
  },
  {
    Contact: "Kasper",
    date: "15 Oct 2024",
    time: "11:49pm",
    type: "incoming",
  },
  {
    Contact: "Kasper",
    date: "15 Oct 2024",
    time: "6:16pm",
    type: "outgoing",
  },
  {
    Contact: "Charlotte",
    date: "14 Oct 2024",
    time: "9:32pm",
    type: "incoming",
  },
];
